"use client"

import { extractBlockProperties } from "@/utils/simplifyData"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Image from "next/image"
import "swiper/css"
import { mediaQueries } from "ui/theme/mediaQueries"
import SwiperOnMobile from "../SwiperOnMobile/SwiperOnMobile"
import ActionLinkCardSelector from "../common/ActionLinkCardSelector"
import BlockWrapper from "../common/BlockWrapper"
import DetailsCard from "../common/DetailsCard"
import CommonTitle from "../common/bit/CommonTitle"
import { Desktop, Mobile } from "../common/bit/MediaQueries"
import { sizes } from "../theme/theme"

const StyledBlockWrapper = styled(BlockWrapper)`
  ${mediaQueries.desktopM} {
    padding-left: ${sizes.baseSingle};
    padding-right: ${sizes.baseSingle};
  }
  ${mediaQueries.desktopXl} {
    padding-left: 40px;
    padding-right: 40px;
  }
`

const StyledCard = styled(Box)`
  display: flex;
  flex-direction: column;

  align-items: center;
  gap: ${sizes.basePenta};
  align-self: stretch;
  border-radius: ${sizes.borderRadiusLarge};
  background: rgba(255, 255, 255, 0.9);
  box-shadow: -16px 20px 60px 0px rgba(2, 1, 64, 0.12);
  backdrop-filter: blur(15px);
  ${mediaQueries.desktopM} {
    padding: ${sizes.basePenta} ${sizes.baseTriple};
  }
  ${mediaQueries.desktop} {
    padding: ${sizes.basePenta};
  }
`

const StyledImageBGContainer = styled(Box)`
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 50%;
  bottom: -21px;
  max-width: 100%;
  transform: scaleX(-1);
  ${mediaQueries.mobile} {
    display: none;
  }

  ${mediaQueries.tablet} {
    height: 60%;
    right: 0;
  }

  ${mediaQueries.desktopM} {
    width: 800px;
    height: 100%;
  }
  ${mediaQueries.desktopXl} {
  }
`

const StyledDetailsCard = styled(DetailsCard)`
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: -16px 20px 60px 0px rgba(2, 1, 64, 0.12);
  backdrop-filter: blur(15px);
`

const InvestmentTypes = ({ id, data }: { data: any; id?: string }) => {
  const { title, itemsList } = data
  const itemsListBlocks = extractBlockProperties(itemsList?.blocks)
  return (
    <StyledBlockWrapper id={id} style={{ padding: 0 }}>
      <Desktop>
        <StyledCard>
          {title && <CommonTitle>{title?.value}</CommonTitle>}
          <ActionLinkCardSelector itemsList={itemsList} />
        </StyledCard>
        <StyledImageBGContainer>
          <Image
            sizes="100vw"
            fill
            src="/hachsharaProtectClaim.svg"
            alt={`${title?.value} background image`}
          />
        </StyledImageBGContainer>
      </Desktop>
      <Mobile>
        <SwiperOnMobile
          arrowIconName="arrow_blue_white_line"
          swiperProps={{
            slidesPerView: 1,
            slidesPerGroup: 1,
            navigation: true,
            loop: false,
            centeredSlides: false,
          }}
        >
          {itemsListBlocks?.map((item: any, index: number) => {
            const { title, subtitle, text, itemsList, icon, primaryColor } =
              item

            return (
              <StyledDetailsCard
                key={`investment-type-${index}`}
                data={{
                  title: title,
                  subtitle: subtitle,
                  text: text,
                  itemsList: itemsList,
                  icon: icon?.src,
                  primaryColor: primaryColor || "00A7B5",
                }}
              />
            )
          })}
        </SwiperOnMobile>
      </Mobile>
    </StyledBlockWrapper>
  )
}

export default InvestmentTypes
